import { useDataChange } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })
  return function onChange(value) {
    change(next => {
      next.data.email = value
      next.data.email_template = {
        ...next.data.email_template,
        enabled: true,
      }
    })
  }
}
